import PropTypes from 'prop-types';

import BriefTextField from 'src/components/BriefTextField';
import { UNIFIED_FIELD } from 'src/data/brief';
import { GENERATION_TOOL } from 'src/data/generationTool';
import { countChars } from 'src/lib/string';

import { useLabels } from './labels';

export const FormProductField = ({
  className,
  generationTool,
  content,
  disabled,
  errors,
  InputProps,
  maxChars,
  name,
  onChange,
  hideCounter,
  classes,
}) => {
  const handleChange = (val) => onChange(name, val);

  const labels = useLabels(generationTool, name);

  const value = content[name] || '';
  const charCounter = {
    value: countChars(value),
    max: maxChars,
    strict: true,
  };

  return (
    <BriefTextField
      charCounter={charCounter}
      className={className}
      disabled={disabled}
      displayCharCounter={!hideCounter}
      error={errors && (errors[name] || errors.highlight)}
      InputProps={{
        name,
        ...InputProps,
      }}
      label={labels.label}
      onChange={handleChange}
      placeholder={labels.placeholder}
      value={value}
      classes={classes}
    />
  );
};

FormProductField.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)).isRequired,
  content: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
  errors: PropTypes.shape(),
  InputProps: PropTypes.shape({}),
  maxChars: PropTypes.number.isRequired,
  name: PropTypes.oneOf(Object.values(UNIFIED_FIELD)).isRequired,
  onChange: PropTypes.func.isRequired,
  hideCounter: PropTypes.bool,
};

FormProductField.defaultProps = {
  className: null,
  classes: null,
  disabled: false,
  errors: null,
  InputProps: null,
  hideCounter: false,
};
